import { useEffect, useState } from "react";
import JourneyFormItem from "./JourneyFormItem";
//@ts-ignore
import Pagination from "react-js-pagination";
import { ReactComponent as EmptyStateImage } from "../../images/noGeneralContent.svg";
import { t } from "i18next";
import { UserContextInterface } from "../../state/UserContext";
import { JourneyFormButtonArg } from "../../types/dashboard/JourneyFormDropDownItems";
import { DashboardJourneyTabType } from "../../types/dtos/dashboards/DashboardJourneyTabType";
import JourneyListingDto from "../../types/dtos/dashboards/manager/listings/journey/JourneyListingDto";

interface JourneyFormTabProps {
  userContext: UserContextInterface;
  loggedInUserCurrentJourneyRef: string | null;
  forms: JourneyListingDto[];
  selectedTab: DashboardJourneyTabType;
  onUpdateClick(form: JourneyListingDto): void;
  onViewClick(form: JourneyListingDto): void;
  onDualPrepItemClick(form: JourneyListingDto, arg: JourneyFormButtonArg): void;
}

export const JourneyFormTab = ({
  userContext,
  loggedInUserCurrentJourneyRef,
  forms,
  selectedTab,
  onUpdateClick,
  onViewClick,
  onDualPrepItemClick,
}: JourneyFormTabProps) => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalItemCount, setTotalItemCount] = useState<number>(forms.length);
  const [itemsOnDisplay, setItemsOnDisplay] = useState<JourneyListingDto[]>([]);

  const isCompletedTab = selectedTab === "COMPLETED";

  useEffect(() => {
    // Set the page number to 1 when the forms change
    const pageNum = 1;
    setPageNumber(pageNum);
    calculateItemsToDisplay(pageNum);
    setTotalItemCount(forms.length);
  }, [forms]);

  const handlePageNumberChange = (pageNumber: number) => {
    setPageNumber(pageNumber);
    calculateItemsToDisplay(pageNumber);
  };

  const calculateItemsToDisplay = (newPageNumber: number) => {
    var startIndex = (newPageNumber - 1) * itemsPerPage;
    let displayItems = [...forms].splice(startIndex, itemsPerPage);
    setItemsOnDisplay(displayItems);
  };

  return (
    <div className="journey-form-tab mt-3">
      {forms.length === 0 ? (
        <div className="text-center text-gray-400 pt-4 lg:pt-16">
          <div className="flex justify-center">
            <EmptyStateImage className="max-w-1/2" />
          </div>
          <p className="text-sm pt-2 lg:pt-4">
            {t("Pages.MyDashboard.Forms.EmptyState")}
          </p>
        </div>
      ) : (
        <div className="journey-list-container">
          {itemsOnDisplay.map((journey, index) => (
            <JourneyFormItem
              userContext={userContext}
              key={`form_item_${journey.journeyReference}_${index}`}
              journey={journey}
              isCompletedTab={isCompletedTab}
              onUpdateClick={onUpdateClick}
              onViewClick={onViewClick}
              onDualPrepItemClick={onDualPrepItemClick}
              loggedInUserCurrentJourneyRef={loggedInUserCurrentJourneyRef}
            />
          ))}

          {totalItemCount > itemsPerPage && (
            <div className="grid grid-cols-1 pt-4 md:grid-cols-5 md:text-gray-500">
              <div className="col-span-3">
                <div className="mt-2 text-xs">
                  <Pagination
                    activePage={pageNumber}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={totalItemCount}
                    pageRangeDisplayed={5}
                    onChange={handlePageNumberChange}
                    activeClass="pagination-active-list-item"
                    itemClass="pagination-list-item"
                    itemClassFirst="pagination-first-item"
                    itemClassLast="pagination-last-item"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
